export default __webpack_public_path__ + "assets/4b61e57bdb8a70cf6b09c0ea77ffd876.png";